import LandingBackground from '../features/outlets/components/LandingBackground'
import OutletSearchCard from '../features/outlets/components/searchOutlets/OutletSearchCard'
import Page from '../features/layout/components/Page'

import styles from './index.module.scss'

function HomePage() {
  return (
    <Page>
      <LandingBackground className={styles.imgContainer}>
        <OutletSearchCard />
      </LandingBackground>
    </Page>
  )
}

export default HomePage
